// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 3H16.5V1H7.5V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 6V4H2V6H4.02898L4.52898 23H12.4994C11.5579 21.7465 11 20.1884 11 18.5V8H13V13.4009C14.3697 11.9242 16.3269 11 18.5 11C18.9506 11 19.3919 11.0397 19.8206 11.1159L19.971 6H22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 18.5C13 15.4624 15.4624 13 18.5 13C21.5376 13 24 15.4624 24 18.5C24 21.5376 21.5376 24 18.5 24C15.4624 24 13 21.5376 13 18.5ZM20.9142 19.5001L19.5 18.0857V16.252H17.5V18.9141L19.4999 20.9142L20.9142 19.5001Z"}}]};

const DeleteTimeFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'delete-time-filled',
    ref,
    icon: element,
  },
));

DeleteTimeFilledIcon.displayName = 'DeleteTimeFilledIcon';

export default DeleteTimeFilledIcon;
